'use client';
import classnames from 'classnames';
import React, { useState } from 'react';
import styles from './Accordion.module.scss';
export var AccordionSize;
(function (AccordionSize) {
    AccordionSize["SMALL"] = "small";
    AccordionSize["LARGE"] = "large";
})(AccordionSize || (AccordionSize = {}));
export const Accordion = ({ className, title, condensedIcon, openTitle, margin = true, size = AccordionSize.LARGE, onChange = () => { }, children, groupName, defaultOpen = false, }) => {
    const [checked, setChecked] = useState(defaultOpen);
    const id = title.replace(/ /g, '_');
    const onCheckedChange = () => {
        const newValue = !checked;
        setChecked(newValue);
        onChange({ checked: newValue, title, groupName });
    };
    return (<div className={classnames(styles.accordion, className)}>
      <div className={classnames(styles.tab, !margin && styles.noMargin)}>
        <input type='checkbox' id={id} onChange={onCheckedChange} checked={checked}/>
        <label className={classnames(styles.tabLabel, condensedIcon && styles.condensedIcon, size === 'large' ? styles.large : styles.small)} htmlFor={id}>
          {checked && openTitle ? openTitle : title}
        </label>
        <div className={classnames(styles.tabContent, size === 'large' ? styles.large : styles.small)}>
          {children}
        </div>
      </div>
    </div>);
};
